import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { EditStoreProps } from '@/main/store/@types/edit.d';

import { NAME, CRUMB_LABEL_KEY, CUSTOMER_FILES, DEPENDENT_TABLES, SUPPLIER_EDIT_HISTORY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	VatId: null as number | null,
	DicNr: null as string | null,
	DodavatelId: null as number | null,
	DodavatelZkt: null as string | null,
	DphPlatcePrp: null as boolean | null,
	EMailAdresa: null as string | null,
	EdiCode: null as string | null,
	EdiProviderId: null as number | null,
	FaxNr: null as string | null,
	IcDphNr: null as string | null,
	IcoNr: null as string | null,
	KontoNr: null as number | null,
	KrukTitulId: null as number | null,
	KrukamJmeno: null as string | null,
	KrukamPrijm: null as string | null,
	Obec: null as string | null,
	Oddeleni: null as string | null,
	PscNr: null as string | null,
	StatId: null as number | null,
	TelefonNr: null as string | null,
	TelexNr: null as string | null,
	TelmobNr: null as string | null,
	Text: null as string | null,
	Ulice: null as string | null,
	ZakaznikId: null as number | null,
	ZakaznikSk: null as number | null,
	PlatbaPZN: null as number | null,
	GSTIN: null as string | null,
	GSTType: null as number | null,
	PAN: null as string | null, // Permanent Account Number
	BankName: null as string | null,
	BankAccountNo: null as string | null,
	DelieveryLeadTime: null as string | null,
	PurchaseOrderType: null as number | null,
	IsApproved: null as number | null,
	VendorStatus: null as string | null,
	SupplierRemarks: null as | string | null,
	SupplierTypeId: null as number | null,
	PrimaryUserRole: null as string | null,
	PrimaryUsers: [] as number[],
	PaymentTerms: null as number | null,
	IsEt2000Supplier: null as boolean | null,
	Et2000SupplierId: null as number | null,
	SupplierNewData: {
		SupplierGSTType: null as number | null,
		SupplierPurchaseOrderType: null as number | null,
		SupplierPlatbaPZN: null as number | null,
	},
	SupplierOldData: {
		SupplierGSTType: null as number | null,
		SupplierPurchaseOrderType: null as number | null,
		SupplierPlatbaPZN: null as number | null,
	},
	UpdatedSupplierData: {
		IsFirstTimeApproved: null as boolean | null,
		IsPlatbaPZNChanged: null as boolean | null,
		IsPANChanged: null as boolean | null,
		IsGSTINChanged: null as boolean | null,
		IsGSTTypeChanged: null as boolean | null,
		IsPurchaseOrderTypeChanged: null as boolean | null,
		IsBankNameChanged: null as boolean | null,
		IsBankAccountNoChanged: null as boolean | null,
		SupplierEditNewData: {
			PlatbaPZN: null as number | null,
			GSTIN: null as string | null,
			GSTType: null as number | null,
			PAN: null as string | null,
			BankName: null as string | null,
			BankAccountNo: null as string | null,
			DelieveryLeadTime: null as string | null,
			PurchaseOrderType: null as number | null,
		},
		SupplierEditOldData: {
			PlatbaPZN: null as number | null,
			GSTIN: null as string | null,
			GSTType: null as number | null,
			PAN: null as string | null,
			BankName: null as string | null,
			BankAccountNo: null as string | null,
			DelieveryLeadTime: null as string | null,
			PurchaseOrderType: null as number | null,
		},
	},
	IsExtLoProvider: null as boolean | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VatId: [],
		KrukTitulId: [],
		StatId: [],
		ZakaznikSk: [],
		PlatbaPZN: [],
		GSTType: [],
		PurchaseOrderType: [],
		GetSupplierType: [],
		SupplierGSTTypeNew: [],
		SupplierGSTTypeOld: [],
		SupplierPurchaseOrderTypeOld: [],
		SupplierPurchaseOrderTypeNew: [],
		SupplierPlatbaPZNNew: [],
		SupplierPlatbaPZNOld: [],
	},
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[CUSTOMER_FILES]: {
			loadByEntityId: true,
			filter(state) { return { ZakaznikId: state.props.id }; },
		},
		[SUPPLIER_EDIT_HISTORY]: {
			filter(state) {
				return {
					ZakaznikId: state.edit.DodavatelId, wantRows: true,
				};
			},
		},
	},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: { ShowCreate: false },
		mode: null,
	} as EditStoreProps,
});
